<template>
    <div class="allbox">
        <div class="swiper-container2">
            <div class="swiper-wrapper">
                <div class="swiper-slide page4 ani" swiper-animate-effect="fadeInLeft" swiper-animate-duration="1s">
                    <div class="ani " swiper-animate-effect="fadeInLeft" swiper-animate-duration="3s">
                        <div class="topdateBox">
                            <p class="ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="1s"><img
                                    src="../assets/datebg.png" alt=""></p>
                            <p class="dateText ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="1s"
                               swiper-animate-delay="1s">
                                <span>{{queryData.year}}</span>
                                <span>&nbsp;/&nbsp;</span>
                                <span>{{queryData.mounth}}</span>
                                <span>&nbsp;/&nbsp;</span>
                                <span>{{queryData.day}}</span>
                            </p>
                        </div>
                        <div class="main">
                            <p class="nimenzai"><img src="../assets/nimenzia.png" alt=""></p>
                            <p class="addresstext" :style="addressText_style">“{{this.queryData.city}}”</p>
                            <p class="xiangyu"><img src="../assets/xiangyu.png" alt=""></p>
                            <p class="dian"><img src="../assets/dian.png" alt=""></p>
                            <p class="xiangyunatian"><img src="../assets/tian.png" alt=""></p>
                            <p class="tianqi">“{{this.queryData.todayweather | text}}”</p>
                            <p class="renwu"><img src="../assets/renwu.png" alt=""></p>
                            <p class="downText">
                                <img src="../assets/wulun.png" alt="">
                            </p>

                            <div class="dowmBox">
                                <p class="downimg ani" swiper-animate-effect="fadeIn">
                                    <img src="../assets/xiangxia.png" alt="">
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-slide page5">
                    <div class="imgbox" v-show="true">
                        <img :src="dataURL" alt="">
                    </div>
                    <p class="changantext"># 长按保存图片分享 #</p>
                    <div class="toimages" ref="imageWrapper">
                        <div class="logo" :style="logopadding">
                            <img src="../assets/p5toplogo.png" alt="">
                        </div>
                        <div class="main">
                            <p class="p5person"><img src="../assets/p5renwu.png" alt=""></p>
                            <div class="toptext">
                                <p class="bg"><img src="../assets/p5toptextbg.png" alt=""></p>
                                <p class="nametext yname" :style="sms10style.top_1">{{this.queryData.name1}}</p>
                                <p class="nametext hname" :style="sms10style.top_2">{{this.queryData.name2}}</p>
                                <p class="numtext qnum">{{this.queryData.qnum}}</p>
                                <p class="numtext ynum" :style="sms10style.left">{{this.queryData.ynum}}</p>
                            </div>
                            <!--                            <p class="dian">-->
                            <!--                                <img src="../assets/p5dian.png" alt="">-->
                            <!--                            </p>-->
                            <!--                                                        <p class="guanjianci">相遇关键词</p>-->
                            <div class="qrcode">
                                <img :src="this.guanjianciSrc" alt="">
                                <p class="qrimg"><img src="../assets/weather_prod.png" alt=""></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import html2canvas from 'html2canvas'

    export default {
        name: 'result',
        data() {
            return {
                dataURL: '',
                queryData: '',
                guanjianciSrc: '',
                logopadding: {
                    paddingTop: '3.1%',
                    paddingBottom: '3.2%'
                },
                imgHeight: 600,
                sms10style:'',
                addressText_style: ''
            }
        },
        methods: {

            toImage() {
                let _this = this
                html2canvas(this.$refs.imageWrapper, {
                    backgroundColor: null,
                    scale: 2,
                    dpi: window.devicePixelRatio * 4,
                    imgHeight: _this.imgHeight
                }).then((canvas) => {
                    const context = canvas.getContext('2d')
                    // 【重要】关闭抗锯齿 https://segmentfault.com/a/1190000011478657
                    context.mozImageSmoothingEnabled = false
                    context.webkitImageSmoothingEnabled = false
                    context.msImageSmoothingEnabled = false
                    context.imageSmoothingEnabled = false

                    let dataURL = canvas.toDataURL('image/png')
                    this.dataURL = dataURL
                })
            },
            codeToSrc1() {
                switch (this.queryData.todayweather) {
                    case '0' :
                        this.guanjianciSrc = "./images/QING_G.png"
                        break
                    case '1' :
                        this.guanjianciSrc = "./images/YING.png"
                        break
                    case '2' :
                        this.guanjianciSrc = "./images/YU.png"
                        break
                    case '3' :
                        this.guanjianciSrc = "./images/XUE.png"
                        break
                }
            },
            codeToSrc() {
                switch (this.queryData.todayweather) {
                    case '0' :
                        this.guanjianciSrc = require('../assets/QING_G.png')
                        break
                    case '1' :
                        this.guanjianciSrc = require('../assets/YING.png')
                        break
                    case '2' :
                        this.guanjianciSrc = require('../assets/YU.png')
                        break
                    case '3' :
                        this.guanjianciSrc = require('../assets/XUE.png')
                        break
                }
            }
        },
        created() {
            console.log(this.$route.query)
            this.queryData = this.$route.query
        },
        mounted() {
            var that = this
            this.codeToSrc()
            // alert(this.queryData.city.length)
            if(this.queryData.city.length < 10){
                this.addressText_style = {
                    fontSize: '.2rem'
                }
            }
            if(this.queryData.city.length > 10){
                this.addressText_style = {
                    fontSize: '.18rem'
                }
            }
            if(this.queryData.city.length > 11){
                this.addressText_style = {
                    fontSize: '.16rem'
                }
            }
            if(this.queryData.city.length > 12){
                this.addressText_style = {
                    fontSize: '.14rem'
                }
            }
            if(this.queryData.city.length > 13){
                this.addressText_style = {
                    fontSize: '.12rem'
                }
            }
            if(this.queryData.city.length > 14){
                this.addressText_style = {
                    fontSize: '.1rem'
                }
            }
            if(this.queryData.city.length > 15){
                this.addressText_style = {
                    fontSize: '.08rem'
                }
            }

            //三星s10
            if(navigator.userAgent.toLowerCase().indexOf('sm-g9730') > -1){
                this.logopadding = {
                    paddingTop: '10.7%',
                    paddingBottom: '7.2%'
                }

                this.sms10style = {
                    left:{
                        left:'1.2rem'
                    },
                    top_1:{
                        top:'-.03rem',
                        right:'59%'
                    },

                    top_2:{
                        left:'55%',
                        top:'-.03rem',
                    }
                }
            }
            //iphoneX
            let screenHeight = window.screenWidth = document.body.clientHeight
            if (screenHeight > 720) {
                this.logopadding = {
                    paddingTop: '10.7%',
                    paddingBottom: '7.2%'
                }
                // this.imgHeight = 527
            }
            zhuge.track('天气之子异业合作', {
                '生成页曝光PVUV': 'h5_weatherson_result_sw'
            })
            // console.log(JSON.stringify( {
            //     '生成页曝光PVUV': 'h5_weatherson_result_sw'
            // }));
            var mySwiper2 = new Swiper('.swiper-container2', {
                direction: 'vertical',
                on: {
                    init() {
                        // swiperAnimateCache(this); //隐藏动画元素
                        swiperAnimate(this) //初始化完成开始动画
                    },
                    slideChangeTransitionEnd: function () {
                        swiperAnimate(this)
                        if(this.activeIndex === 1) {            
                            setTimeout(() => {
                                that.toImage()
                            }, 400)
                        }
                        // $(this.slides).eq(this.activeIndex).find('.ani').removeClass('ani')
                    }
                }
            })
            // this.$nextTick(() => {
            //     setTimeout(() => {
            //         this.toImage()
            //     }, 400)
            // })
        }
    }
</script>

<style scoped lang="scss">
    .allbox {
        width: 100%;
        height: 100%;

        .swiper-container2 {
            width: 100%;
            height: 100%;

            .swiper-wrapper {
                width: 100%;
                height: 100%;

                .swiper-slide {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;
                }

                .page4 {
                    /*padding-top: .355rem;*/
                    /*display: flex;*/
                    /*flex-direction: column;*/
                    /*justify-content: space-between;*/
                    /*align-items: center;*/
                    /*position: relative;*/
                    & > div {
                        padding-top: .25rem;
                        background: url('../assets/page_4_bg.png') no-repeat;
                        background-size: cover;
                        width: 100%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        /* justify-content: space-between; */
                        align-items: center;
                    }

                    .topdateBox {
                        width: 1.5rem;

                        .dateText {
                            color: #fff;
                            font-size: .24rem;
                        }

                        img {
                            width: 100%;
                        }
                    }

                    .main {
                        height: 78%;
                        width: 74%;
                        background-size: 100%;
                        /* background-position: 7px; */
                        margin-top: .1rem;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        padding-top: 5%;
                        background: url("../assets/page4_mainbg.png") no-repeat;
                        background-size: 100%;
                        position: relative;

                        .nimenzai {
                            width: 13.2%;

                            img {
                                width: 100%;
                            }
                        }

                        .dowmBox {
                            position: absolute;
                            bottom: -.3rem;

                            .downimg {
                                animation-iteration-count: infinite !important;
                                width: .25rem;

                                img {
                                    width: 100%;
                                }
                            }
                        }

                        .addresstext {
                            width: 80%;
                            color: #f85b8d;
                            /*font-size: .2rem;*/
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            text-align: center;
                        }

                        .xiangyu {
                            width: 9%;
                            padding-top: 2%;

                            img {
                                width: 100%;
                            }
                        }

                        .dian {
                            width: 70%;
                            padding-top: 2.3%;
                            font-size: 0;

                            img {
                                width: 100%;
                            }
                        }

                        .xiangyunatian {
                            width: 35%;
                            padding-top: .8%;

                            img {
                                width: 100%;
                            }
                        }

                        .tianqi {
                            font-size: .2rem;
                            color: #397dec;
                            /*padding-top: .05rem;*/
                        }

                        .renwu {
                            width: 80%;
                            font-size: 0;
                            padding-top: .8%;

                            img {
                                width: 100%;
                            }
                        }

                        .downText {
                            width: 50%;
                            padding-top: .2rem;

                            img {
                                width: 100%;
                            }
                        }
                    }
                }

                .page5 {

                    position: relative;

                    .changantext {
                        width: 100%;
                        text-align: center;
                        color: #fff;
                        font-size: .16rem;
                        position: absolute;
                        bottom: .1rem;
                        z-index: 1000000;
                        /*background: rebeccapurple;*/
                        -webkit-touch-callout: none;
                        -webkit-user-select: none;
                        -khtml-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                    }

                    .imgbox {
                        user-select:auto !important;
                        -moz-user-select: auto !important;
                        img {
                            width: 100%;
                            user-select:auto !important;
                            -moz-user-select: auto !important;
                            -webkit-user-select: auto !important;
                            position: absolute;
                            top: 0;
                            left: 0;
                            z-index: 499;

                        }
                    }

                    .toimages {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        background: url("../assets/page_4_bg.png") no-repeat;
                        background-size: cover;
                        width: 100%;
                        height: 100%;
                    }

                    .main {
                        width: 86%;
                        height: 83%;
                        background: url("../assets/p5mainBG.png") no-repeat;
                        background-size: 100%;
                        display: flex;
                        align-items: center;
                        flex-direction: column;
                        background-position: 0 -2%;
                        /*background-position: 0 97%;*/
                        /*padding-top:.8rem ;*/
                    }

                    .logo {
                        width: 44.3%;
                        padding-top: 3.1%;
                        padding-bottom: 3.2%;

                        img {
                            width: 100%;
                        }
                    }

                    .p5person {
                        width: 87%;
                        padding-top: 5.5%;

                        img {
                            width: 100%;
                        }
                    }

                    .toptext {
                        /*background: url("../assets/p5toptextbg.png") no-repeat;*/
                        width: 80%;
                        /*height: .9rem;*/
                        background-size: 100%;
                        margin-top: .12rem;
                        position: relative;
                        height: 0.75rem;

                        .bg {
                            position: absolute;
                            top: 0;
                            left: 0;

                            img {
                                width: 100%;
                                z-index: 0;
                            }
                        }

                        .nametext {
                            font-size: .2rem;
                            font-weight: 600;
                            position: absolute;
                            color: #f88d10;
                            top: -0.1rem;
                            z-index: 1;
                            line-height: 0.34rem;
                        }

                        .yname {
                            right: 57%;
                            z-index: 1;
                        }

                        .hname {
                            left: 57%;
                            z-index: 1;
                        }

                        .numtext {
                            width: .67rem;
                            text-align: center;
                            color: #f88d10;
                            font-size: .2rem;
                            position: absolute;
                            top: .455rem;
                            font-weight: 600;
                            /*background: red;*/
                        }

                        .ynum {
                            position: absolute;
                            left: 1.4rem;
                        }
                    }

                    .dian {
                        width: 81%;

                        img {
                            width: 100%;
                        }
                    }

                    .guanjianci {
                        color: #f88d10;
                        font-size: .14rem;
                    }

                    .qrcode {
                        width: 60%;
                        padding-top: 0.35rem;
                        position: relative;

                        .qrimg {
                            width: 25%;
                            position: absolute;
                            bottom: 29%;
                            left: 2.3%;
                            z-index: 0;

                            img {
                                width: 100%;
                                position: absolute;
                            }
                        }

                        img {
                            width: 100%;
                        }
                    }


                }
            }
        }
    }
</style>